<script>
import axios from '@/utils/axios';

export default {
 inject: ['setLoading'],
 data() {
  return {
    title: "Inventory",
    text: "Inventory",
    activity_logs: [],
    activity_return_number: '',
    search: '',
    data: [],
    stats: [],
    activeStatus: '',
    pagination: {
     current_page: 1,
     per_page: 25,
     last_page: 1,
     total: 0,
     links: [],
    },
   };
  },

  computed: {
   text1(){
    return `Delivery Challan Returns (${this.pagination.total})`;
   }, 
   serialNo(){
    return (this.pagination.current_page - 1) * this.pagination.per_page;
   } 
  },

  mounted(){
    this.loadReturns();
    this.loadStats();

    // Auto-open create modal if redirected from DC listing
    if (this.$route.query.create_from_dc) {
      this.$nextTick(async () => {
        await this.$refs.returnModal.openReturn();
        this.$refs.returnModal.onChallanSelect(parseInt(this.$route.query.create_from_dc));
        this.$openModal('return_dc_modal');
        this.$router.replace({ query: {} });
      });
    }
  },

  methods: {

    onUpdated() {
      this.loadReturns();
      this.loadStats();
    },

    filterByStatus(status) {
      if (this.activeStatus === status) {
        this.activeStatus = '';
      } else {
        this.activeStatus = status;
      }
      this.loadReturns();
    },

    async loadStats() {
      try {
        const response = await axios.get('/inventory/delivery-challan-returns/stats');
        this.stats = response.data.data;
      } catch (error) {
        console.log('Stats load error:', error.message);
      }
    },

    formatDateTime(dateStr) {
      if (!dateStr) return '-';
      const d = new Date(dateStr);
      return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) 
        + ', ' + d.toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', hour12: true });
    },

    openActivityLog(row) {
      this.activity_logs = row.activities || [];
      this.activity_return_number = row.return_dc_number;
      this.$openModal('return_activity_modal');
    },

    async openCreateReturn() {
      await this.$refs.returnModal.openReturn();
      this.$openModal('return_dc_modal');
    },

    async loadReturns(page = 1) {
     this.setLoading(true);
     try{
      const params = {
       page,
       search: this.search.trim() || '',
       status: this.activeStatus || ''
      };
      const query_string = new URLSearchParams(params).toString();
      const response = await axios.get(`/inventory/delivery-challan-returns?${query_string}`);
      this.data = response.data.data.data;
      this.pagination = {
        current_page: response.data.data.current_page,
        per_page: response.data.data.per_page,
        last_page: response.data.data.last_page,
        total: response.data.data.total,
        links: response.data.data.links
      };
     }catch(error){
      this.$swalToast(error.message, 'error');
     }finally{
      this.setLoading(false);
     }
    },

    changePage(url){
     if (!url) return;
     const page = new URL(url).searchParams.get("page");
     this.loadReturns(page);
    },

    clearFilter(){
     this.search = '';
     this.activeStatus = '';
     this.loadReturns();
    },

    statusBadge(status) {
      const map = {
        created: 'bg-warning-subtle text-warning',
        completed: 'bg-success-subtle text-success',
      };
      return map[status] || 'bg-secondary-subtle text-secondary';
    },

    formatDate(dateStr) {
     if (!dateStr) return '-';
     const d = new Date(dateStr);
     return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
    },

    formatCurrency(val) {
     return parseFloat(val || 0).toLocaleString('en-IN', { style: 'currency', currency: 'INR' });
    },

    challanNumber(row) {
      return row.delivery_challan?.challan_number || '-';
    },

    recipientName(row) {
      const dc = row.delivery_challan;
      if (!dc) return '-';
      if (dc.recipient_type === 'App\\Models\\Customer') {
        return dc.recipient_details?.company_name || dc.recipient_details?.name || '-';
      }
      if (dc.recipient_type === 'App\\Models\\WorkOrder') {
        return dc.recipient_details?.name || '-';
      }
      // Engineer
      return dc.recipient_details?.name || '-';
    },

    returnItemsCount(row) {
      return row.return_items?.length || 0;
    },

    openViewChallan(id) {
      window.open(`/inventory/delivery-challans/view/${id}`, '_blank');
    },

    async markComplete(row) {
      if (row.status !== 'created') return;
      try {
        const result = await this.$swal({
          title: 'Mark as Complete?',
          text: `Are you sure you want to complete ${row.return_dc_number}? Stock will be updated (IN) for all returned items.`,
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: 'Yes, Complete',
          cancelButtonText: 'Cancel',
          confirmButtonColor: '#e84040',
        });
        if (result.isConfirmed) {
          this.setLoading(true);
          const response = await axios.patch(`/inventory/delivery-challan-returns/${row.id}/complete`);
          this.$swalToast(response.data.message);
          this.loadReturns(this.pagination.current_page);
          this.loadStats();
        }
      } catch (error) {
        this.$swalToast(error.message, 'error');
      } finally {
        this.setLoading(false);
      }
    },

    async deleteReturn(row) {
      try {
        const result = await this.$swal({
          title: 'Delete Return?',
          text: `Are you sure you want to delete ${row.return_dc_number}? This action cannot be undone.`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, Delete',
          cancelButtonText: 'Cancel',
          confirmButtonColor: '#e84040',
        });
        if (result.isConfirmed) {
          this.setLoading(true);
          const response = await axios.delete(`/inventory/delivery-challan-returns/${row.id}`);
          this.$swalToast(response.data.message);
          this.loadReturns(this.pagination.current_page);
          this.loadStats();
        }
      } catch (error) {
        this.$swalToast(error.message, 'error');
      } finally {
        this.setLoading(false);
      }
    },

  },
};
</script>

<template>
<layout-header></layout-header>
<layout-sidebar></layout-sidebar>

<!-- Page Wrapper -->
<div class="page-wrapper">
  <div class="content">
    <!-- Breadcrumb -->
    <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
      <breadcrumb :title="title" :text="text" :text1="text1" />
      <div class="d-flex my-xl-auto right-content align-items-center flex-wrap gap-2">
        <!-- <a href="javascript:void(0);" class="btn btn-primary d-flex align-items-center" @click="openCreateReturn()">
          <i class="ti ti-circle-plus me-2"></i>Create Return DC
        </a> -->
      </div>
    </div>
    <!-- /Breadcrumb -->

    <!-- Stats Cards -->
    <div class="row g-3 mb-3" v-if="stats && stats.length">
      <div class="col" v-for="stat in stats" :key="stat.status">
        <div class="card mb-0 border-0 shadow-sm" style="cursor:pointer;" :style="activeStatus === stat.status ? 'border: 1px solid #1a56db !important;' : ''" @click="filterByStatus(stat.status)">
          <div class="card-body p-3">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="badge rounded-pill" :class="stat.bg_color" style="font-size:10px;text-transform:capitalize;">
                {{ stat.status.replace('_', ' ') }}
              </span>
              <span class="fw-bold text-dark" style="font-size:20px;">{{ stat.count }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Stats Cards -->

    <div class="card">
      <div class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
        <h5>Delivery Challan Returns</h5>
        
        <div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
          <div class="me-3" v-if="search">
            <a href="javascript:void(0);" class="text-danger" @click="clearFilter()"><i class="ti ti-filter-x"></i></a>
          </div>  

          <div class="me-3">
            <div class="input-icon-end position-relative">
              <input type="text" class="form-control" v-model="search" placeholder="Search...."/>
            </div>
          </div>

          <div class="me-3">
            <button type="button" class="btn btn-dark" @click="loadReturns()"><i class="ti ti-search"></i></button>
          </div>
        </div>
      </div>

      <div class="card-body card-table-wrapper">
        <div class="custom-datatable-filter table-responsive">
          <table class="card-table" v-if="data.length">
            <thead>
              <tr>
                <th>#</th>
                <th>Return DC No</th>
                <th>Challan No</th>
                <th>Recipient</th>
                <th>Return Date</th>
                <th>Items</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in data" :key="row.id">
                <td>{{ serialNo + index + 1 }}.</td>  
                <td>
                  <span class="fw-semibold">{{ row.return_dc_number }}</span>
                </td>
                <td>
                  <a class="text-primary" href="javascript:void(0);" @click="openViewChallan(row.delivery_challan_id)">
                    {{ challanNumber(row) }}
                  </a>
                </td>
                <td>{{ recipientName(row) }}</td>
                <td>{{ formatDate(row.return_date) }}</td>
                <td>
                  <span class="badge bg-light text-dark border rounded-pill">{{ returnItemsCount(row) }} item(s)</span>
                </td>
                <td>
                  <span class="badge rounded-pill" :class="statusBadge(row.status)">
                    {{ row.status.charAt(0).toUpperCase() + row.status.slice(1) }}
                  </span>
                </td>
                <td>
                  <div class="dropdown">
                    <button class="btn btn-icon btn-sm rounded-circle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                      <i class="ti ti-dots-vertical"></i>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-end p-3">
                      <li>
                        <a class="dropdown-item rounded-1" href="javascript:void(0);" @click="openActivityLog(row)">
                          <i class="ti ti-activity me-1"></i>History
                        </a>
                      </li>
                      <li v-if="row.status === 'created'">
                        <a class="dropdown-item rounded-1" href="javascript:void(0);" @click="markComplete(row)">
                          <i class="ti ti-check me-1"></i>Mark Complete
                        </a>
                      </li>
                      <li v-if="row.status === 'created'">
                        <a class="dropdown-item rounded-1 text-danger" href="javascript:void(0);" @click="deleteReturn(row)">
                          <i class="ti ti-trash me-1"></i>Delete
                        </a>
                      </li>
                    </ul>
                  </div>  
                </td>
              </tr>
            </tbody>
          </table>

          <div v-else class="p-3 text-center text-muted"> No records found. </div>
        </div>

        <!-- Pagination -->
        <nav v-if="pagination.links.length > 3" class="m-3">
          <ul class="pagination pagination-sm">
            <li v-for="(link, index) in pagination.links" :key="index"
              :class="['page-item', { active: link.active, disabled: !link.url }]">
              <a class="page-link" href="javascript:void(0)" v-html="link.label" @click="changePage(link.url)"></a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>

  <app-footer></app-footer>
</div>
<!-- /Page Wrapper -->

<!-- Return Activity Modal -->
<div class="modal fade" id="return_activity_modal" tabindex="-1">
  <div class="modal-dialog modal-dialog-scrollable modal-md">
    <div class="modal-content">
      <div class="modal-header border-0 pb-0">
        <div>
          <h5 class="modal-title fw-bold mb-1">Activity Log</h5>
          <span class="text-muted fs-12">{{ activity_return_number }}</span>
        </div>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body" style="padding-top: 2px !important">

        <div v-if="activity_logs.length" class="position-relative ms-3">
          <!-- Timeline line -->
          <div class="position-absolute" style="left: 6px; top: 12px; bottom: 12px; width: 2px; background: #e9ecef;"></div>

          <div v-for="(log, index) in activity_logs" :key="log.id" class="d-flex align-items-start mb-3 position-relative">
            <!-- Timeline dot -->
            <div class="rounded-circle flex-shrink-0 me-3 position-relative" 
                 :style="{
                   width: '14px', height: '14px', 
                   background: index === 0 ? '#0d6efd' : '#adb5bd',
                   border: '2px solid #fff',
                   boxShadow: '0 0 0 2px ' + (index === 0 ? '#0d6efd' : '#dee2e6'),
                   zIndex: 1
                 }">
            </div>
            <!-- Content card -->
            <div class="card border shadow-none w-100 mb-0" :class="index === 0 ? 'border-primary border-opacity-25' : ''">
              <div class="card-body p-2 px-3">
                <p class="mb-1 fs-13" v-html="log.description"></p>
                <small class="text-muted">
                  <i class="ti ti-clock me-1"></i>{{ formatDateTime(log.created_at) }}
                </small>
              </div>
            </div>
          </div>
        </div>

        <div v-else class="text-center text-muted py-5">
          <i class="ti ti-history fs-1 d-block mb-2 opacity-50"></i>
          <p class="mb-0">No activity found.</p>
        </div>

      </div>
      <div class="modal-footer border-0 pt-0">
        <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<delivery-challan-return-modal ref="returnModal" @updated="onUpdated"></delivery-challan-return-modal>

</template>


<style scoped>
.table-responsive {
  overflow-y: auto;
}
</style>